import React from 'react'
import Copy from '../../atoms/Copy'
import * as S from './styles'

type Props = {
  title: string | React.ReactNode
  subTitle?: string | React.ReactNode
  copyText?: string
  imgUrl?: string
  button?: string
  onClick?: () => void
}

const ContentsTitle = ({ title, subTitle, copyText = '', imgUrl, button, onClick }: Props) => {
  return (
    <S.ContentsContainer>
      <S.ContentsTitleStyle copyText={copyText}>
        {imgUrl && <S.Img alt="symbolImg" src={imgUrl} />}
        {title}
        {copyText ? (
          <S.Span>
            {copyText} <Copy text={copyText} />
          </S.Span>
        ) : null}
        {button && <S.Button onClick={onClick}>{button}</S.Button>}
      </S.ContentsTitleStyle>
      {subTitle ? <>{subTitle}</> : null}
    </S.ContentsContainer>
  )
}

export default ContentsTitle
